import React from "react";
import {
  Route,
  Routes,
} from "react-router-dom";
import WelcomeScreen from "./WelcomeScreen.js";
import AdminRoute from "../components/AdminRoute.js";

const BarcodesList = React.lazy(() => import("./barcodesList.js"));
const AddCustomer = React.lazy(() => import("./AddCustomer"));
const CustomerList = React.lazy(() => import("./CustomersList"));
const AmountDepositeScreen = React.lazy(() => import("./AmountDepositeScreen"));
const Inventory = React.lazy(() => import("./Inventory"));
const ImportedData = React.lazy(() => import("./Imports.js"));
const Analytics = React.lazy(() => import("./benfitScreen.js"));
const Attendance = React.lazy(() => import("./Attendance.js"));
const Vendors = React.lazy(() => import("./Vendors.js"));
const ResetPassword = React.lazy(() => import("./ResetPassword.js"));

function HomePage() {
  return (
    <div>
      <div className="mt-50">
        <React.Suspense
          fallback={
            <>
              {/* <Loader /> */}
            </>
          }
        >
          <Routes>
          <Route
              path="/home"
              element={
                <React.Suspense fallback="">
                  <WelcomeScreen />
                </React.Suspense>
              }
            />
            <Route
              path="/"
              element={
                <React.Suspense fallback="">
                  <WelcomeScreen />
                </React.Suspense>
              }
            />
            <Route
              path="/createCustomer"
              element={
                <React.Suspense fallback="">
                  <AddCustomer />
                </React.Suspense>
              }
            />
            <Route
              path="/summary"
              element={
                <React.Suspense fallback="">
                  <Inventory />
                </React.Suspense>
              }
            />
            <Route
              path="/customerList"
              element={
                <React.Suspense fallback="">
                  <CustomerList />
                </React.Suspense>
              }
            />
            <Route
              path="/amountHistory"
              element={
                <React.Suspense fallback="">
                  <AmountDepositeScreen />
                </React.Suspense>
              }
            />
            <Route
              path="/imports"
              element={
                <AdminRoute>
                  <React.Suspense fallback="">
                    <ImportedData />
                  </React.Suspense>
                </AdminRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <AdminRoute>
                  <React.Suspense fallback="">
                    <Analytics />
                  </React.Suspense>
                </AdminRoute>
              }
            />
            <Route
              path="/attendance"
              element={
                <React.Suspense fallback="">
                  <Attendance />
                </React.Suspense>
              }
            />
            <Route
              path="/list-vendors"
              element={
                <AdminRoute>
                  <React.Suspense fallback="">
                    <Vendors />
                  </React.Suspense>
                </AdminRoute>
              }
            />
            <Route
              path="/barcodes"
              element={
                <React.Suspense fallback="">
                  <BarcodesList />
                </React.Suspense>
              }
            />
            <Route
              path="/resetpassword"
              element={
                <React.Suspense fallback="">
                  <ResetPassword />
                </React.Suspense>
              }
            />
          </Routes>
        </React.Suspense>
      </div>
    </div>
  );
}

export default HomePage;
